import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import {useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import ArticalNumber from './articalNumber'


const MerchForm3 = ({ lineItemIndex,invoiceIndex, isFormDisabled, invoiceId, merchandiseId, saveData,updateData,isDMS,onChange, fieldPattern, validateError,procedureList }) => {
  
  const addProcedureList = useSelector((state) => state.DropDownValues?.addProcedure111) || []
  const procedure =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.procedure) || ''
  const addProcedure =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addProcedure) || ''
  const addProcedureId =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.addProcedureId)
  
  const translate = React.useContext(TranslateContext).translate

  const { lineItem } = fieldPattern()?.items
  const procedureErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_procedure`])
  
  
  return (
    <Grid.Row>
          <Grid.Column width={isDMS ? 8 : 5} className='divFormFeild b-rw-0'>
            <DropDown
              id={`procedure-${invoiceId}-${merchandiseId}`}
              label={translate('PROCEDURE', { ns: ['default', 'lineItem'] })}
              disabled={isFormDisabled}
              className='field-bg dropdown100 addInfoCode'
              boxNumber={isDMS ? '4/18' : ''}
              labelClass='text-none'
              isLabel={true}
              clearable
              // errors={procedureErr && procedureErr?.msg}
              data={procedureList}
              errors={(procedureErr && [procedureErr?.msg] )}
              value={procedure}
              onChange={(value) => {
                updateData({procedure:value?.trim()})
                saveData({procedure:value})
                const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_procedure`
                  validateError({[key]:""},{[key]:value},
                  {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.procedure}
                )
              }}
              
            />
            
          </Grid.Column>
          <Grid.Column width={isDMS ? 8 : 5} className='divFormFeild  b-rw-0'>
            <DropDown
              id={`addProcedure-${invoiceId}-${merchandiseId}`}
              label={translate('ADD_PROCEDURE', { ns: ['default', 'lineItem'] })}
              disabled={isFormDisabled}
              className='field-bg dropdown100 addInfoCode'
              boxNumber={isDMS ? '1/11' : ''}
              labelClass='text-none'
              isLabel={true}
              mandatory={false}
              direction='left'
              clearable
              data={addProcedureList}
              value={addProcedure}
              onChange={(value) => {
                updateData({addProcedure:value?.trim(),addProcedureId})
                onChange("addProcedureId",{addProcedure:value,addProcedureId})
              }}              
            />
            
          </Grid.Column>

         { !isDMS && 
         <Grid.Column width='6' className='divFormFeild'>
            <ArticalNumber               
              invoiceId={invoiceId}
              invoiceIndex={invoiceIndex}
              lineItemIndex={lineItemIndex}
              id={`artNumber-${invoiceId}-${merchandiseId}`}
              updateData={updateData}
              saveData={saveData}           
            /> 
          </Grid.Column>
}
    </Grid.Row>
  )
}

export default React.memo(MerchForm3)

